<div class="modal-header">
  <h4 class="modal-title">{{'finalizeLegacyProject.popup.title' | translate}}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh" maxHeightOffset>
    <div class="ps-5">
      <form [formGroup]="form">
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label" for="{{fNumberTextInputName}}">{{'finalizeProject.label.fNumber' | translate}}: *</label>
          <div class="col-md-8 form-inline">
            <div class="d-flex gap-2 align-items-center ">
              <span>{{ 'finalizeLegacyProject.label.fNumberPreFix' | translate }}</span>
              <input class="form-control" formControlName="{{fNumberTextInputName}}" type="text"
                     inputRestricter="^[0-9]*$" maxlength="8"
                     [class.is-invalid]="form.controls[fNumberTextInputName]?.invalid">
            </div>
            <div
              class="invalid-feedback">{{ form.controls[fNumberTextInputName]?.errors?.messageKey | translate: {'0': form.controls[fNumberTextInputName]?.errors?.param} }}
            </div>
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label" for="{{tcVersionInputName}}}">{{'finalizeLegacyProject.label.documentVersion' | translate}}: *</label>
          <div class="col-md-8">
            <input class="form-control" formControlName="{{tcVersionInputName}}" type="text" inputRestricter="^[0-9]*$"
              [class.is-invalid]="form.controls[tcVersionInputName]?.invalid">
            <div class="invalid-feedback">{{form.controls[tcVersionInputName]?.errors?.messageKey | translate: {'0': form.controls[tcVersionInputName]?.errors?.param} }}</div>
          </div>
        </div>
        <div class="mb-3 row" *ngIf="isRailBasedProject">
          <label class="col-md-4 col-form-label" for="{{drawingVersionInputName}}}">{{'finalizeLegacyProject.label.drawingVersion' | translate}}: *</label>
          <div class="col-md-8">
            <input class="form-control" formControlName="{{drawingVersionInputName}}" type="text" inputRestricter="^[0-9]*$"
              [class.is-invalid]="form.controls[drawingVersionInputName]?.invalid">
            <div class="invalid-feedback">{{form.controls[drawingVersionInputName]?.errors?.messageKey | translate: {'0': form.controls[drawingVersionInputName]?.errors?.param} }}</div>
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label" for="{{articleNumberLongInputName}}}">{{'finalizeLegacyProject.label.articleNumberLong' | translate}}:</label>
          <div class="col-md-8">
            <input class="form-control" formControlName="{{articleNumberLongInputName}}" type="text" inputRestricter="^[0-9A-Z-/]*$"
              [class.is-invalid]="form.controls[articleNumberLongInputName]?.invalid">
            <div class="invalid-feedback">{{form.controls[articleNumberLongInputName]?.errors?.messageKey | translate: {'0': form.controls[articleNumberLongInputName]?.errors?.param} }}</div>
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label" for="{{articleNumberInputName}}}">{{'finalizeProject.label.articleNumber' | translate}}:</label>
          <div class="col-md-8">
            <input class="form-control" formControlName="{{articleNumberInputName}}" type="text" inputRestricter="^[0-9A-Z-/]*$"
              [class.is-invalid]="form.controls[articleNumberInputName]?.invalid" >
            <div class="invalid-feedback">{{form.controls[articleNumberInputName]?.errors?.messageKey | translate: {'0': form.controls[articleNumberInputName]?.errors?.param} }}</div>
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label" for="{{drawingNumberInputName}}}">{{'finalizeProject.label.drawingNumber' | translate}}:</label>
          <div class="col-md-8">
            <input class="form-control" formControlName="{{drawingNumberInputName}}" type="text" inputRestricter="^[0-9A-Z-/]*$"
              [class.is-invalid]="form.controls[drawingNumberInputName]?.invalid" >
            <div class="invalid-feedback">{{form.controls[drawingNumberInputName]?.errors?.messageKey | translate: {'0': form.controls[drawingNumberInputName]?.errors?.param} }}</div>
          </div>
        </div>
        <div class="mb-3 row" *ngIf="isRailBasedProject">
          <label class="col-md-4 col-form-label">{{'finalizeLegacyProject.label.onlyDrawing' | translate}}:</label>
          <div class="col-md-8">
            <div class="form-control form-check">
              <input id="{{onlyDrawingCheckboxName}}" class="form-check-input" formControlName="{{onlyDrawingCheckboxName}}" type="checkbox" value="onlyDrawing">
              <label class="form-check-label" for="{{onlyDrawingCheckboxName}}">{{'finalizeLegacyProject.label.onlyDrawing' | translate}}</label>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button type="button" class="btn btn-primary btn-forward" (click)="finalizeButtonClickHandler()" [disabled]="!validateForm()">{{'global.label.next' | translate}}</button>
</div>
